// extracted by mini-css-extract-plugin
export var actionButton = "_8h-1";
export var actionButtons = "_8h-2";
export var actions = "_8h-0";
export var aiUnread = "_8h-10";
export var alignCenter = "_8h-h";
export var backWrapper = "_8h-3";
export var cellContainer = "_8h-4";
export var checkboxContainer = "_8h-5";
export var contentContainer = "_8h-6";
export var contentHeader = "_8h-8";
export var conversationsTableWrapper = "_8h-s";
export var draftReplyBadgeContainer = "_8h-m";
export var dropdownItem = "_8h-b";
export var dropdownItemsContainer = "_8h-a";
export var dropdownTitle = "_8h-c";
export var errorIcon = "_8h-7";
export var filter = "_8h-d";
export var gray = "_8h-i";
export var headerActionButtons = "_8h-e";
export var headerCheckboxContainer = "_8h-f";
export var icon = "_8h-j";
export var menuContainer = "_8h-k";
export var noMoreTicketsIcon = "_8h-12";
export var noMoreTicketsSubText = "_8h-13";
export var oneLine = "_8h-l";
export var optionsButton = "_8h-n";
export var plus = "_8h-o";
export var portalButtonsWrapper = "_8h-g";
export var red = "_8h-p";
export var scrolledTop = "_8h-9";
export var search = "_8h-q";
export var selectedConversationsCount = "_8h-r";
export var spinner = "_8h-t";
export var strong = "_8h-u";
export var summaryCell = "_8h-v";
export var tableContainer = "_8h-11";
export var tagContainer = "_8h-w";
export var threeDots = "_8h-x";
export var twoLines = "_8h-y";
export var unread = "_8h-z";